import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StoryDrawer from "@/components/StoryDrawer";
import AdminPage from "@/components/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StoryDrawer />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
